import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { logger } from '@/utils/logging'

export const handleCartUnknownError = (error: unknown, context: ShopifyErrorContext) => {
  let message = 'An unknown error occurred'

  if (CombinedGraphQLErrors.is(error)) {
    if (error.errors.length > 0) {
      message = error.errors.map((e) => e.message).join(', ')
    } else {
      message = error.message
    }
  } else if (error instanceof Error) {
    message = error.message
  }

  notifyDatadogShopify('Shopify Cart Unexpected Error', { context, error: { message } })

  return {
    cart: null,
    errors: [{ message, field: null, code: null }],
  }
}

export type ShopifyErrorContext =
  | 'CreateShopifyCart'
  | 'AddLinesShopifyCart'
  | 'RemoveLinesShopifyCart'
  | 'UpdateLinesShopifyCart'
  | 'ApplyDiscountCode'

interface ShopifyDatadogMetadata {
  context: ShopifyErrorContext
  error?: { message: string }
  [p: string]: { message: string } | string | undefined
}

export const notifyDatadogShopify = (error: string, metadata: ShopifyDatadogMetadata) => {
  logger().error(`Critical Shopify Failure`, { metadata, error })
}
